


























import { Component, Prop, Vue } from 'vue-property-decorator';
import EmploymentService from '@/services/EmploymentService';
import { processError } from '@/utils/ComponentUtils';
import GrantDTO from '@/dto/auth/GrantDTO';
import { ChargeComponent } from '@/dto/subscription/SublimeChargeDTO';
import { IEmployment } from '@/dto/payroll/IEmployment';
import Application from "@/state/Application";

@Component
export default class EmploymentTimesheetGrants extends Vue {
  @Prop({ required: true }) employment!: IEmployment;

  private grants: Array<GrantDTO> = [];
  private loading = false;

  mounted(): void {
    this.loadGrants();
  }

  private loadGrants(): void {
    if (!this.employment?.id) return;
    
    Application.startLoading();
    EmploymentService.getGrants(this.employment.id, ChargeComponent.TIMESHEET).then(
      ok => {
        this.grants = ok.data || [];
        Application.stopLoading();
      },
      err => {
        Application.stopLoading();
        processError(err, this);
      }
    );
  }

  private get hasTriggerGrant(): boolean {
    return this.grants.some(grant => grant.a === 'TRIGGER');
  }

  private getScopeName(): string {
    // For now, always display employee/contractor name as specified in requirements
    if (this.employment?.details?.name) {
      return this.employment.details.name;
    }
    return 'Current employee/contractor';
  }

  private provisionGrant(): void {
    if (!this.employment?.id) return;
    
    Application.startLoading();
    EmploymentService.createGrant(
      this.employment.id,
      ChargeComponent.TIMESHEET,
      'TRIGGER',
      null, // scopeProjectId - always null per requirements
      this.employment.id // scopeEmploymentId - always employment id per requirements
    ).then(
      ok => {
        Application.stopLoading();
        this.loadGrants();
      },
      err => {
        Application.stopLoading();
        processError(err, this);
      }
    );
  }
}
